<template>
  <div class="tags-list">
    <template v-if="list?.length">
      <SingleTag
        v-for="tag in list"
        :key="tag.citytagId"
        :tag="mergeTagWithCity(tag)"
        @click="useTag(mergeTagWithCity(tag))"
      />
    </template>
    <template v-else>
      <SkeletonItem
        v-for="el in 3"
        :key="`tag-skeleton-${el}`"
        :skeleton-style="{
          width: '100px',
          height: '32px',
          borderRadius: '8px',
        }"
    /></template>
  </div>
</template>

<script setup lang="ts">
import { SkeletonItem } from '@experience/core-skeleton-lib';

import { type TagType, type TagTypeWithCity } from '@/shared/models/tag';

import SingleTag from './SingleTag.vue';

type TagCity = Pick<TagTypeWithCity, 'cityName' | 'citySlug'>;

const emit = defineEmits(['use-tag']);

const props = defineProps<{
  list: TagType[];
  city: TagCity;
}>();

const mergeTagWithCity = (tag: TagType): TagTypeWithCity => ({ ...tag, ...props.city });

const useTag = (tag: TagTypeWithCity) => {
  emit('use-tag', tag);
};
</script>

<style scoped>
.tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--alias-space-8, 8px);
}
</style>
